<div [ngClass]="{'action-message-container': true, 'box-visible': boxShouldBeVisible, 'box-invisible': !boxShouldBeVisible, 'action-success': actionSuccess, 'action-fail': !actionSuccess} ">
  <div class="action-message-header">
    <span class="action-message-title">{{ actionMessage }}</span>
  </div>
</div>
